import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../../redux/reducers/commonApiSlice";
import { ivr_initiate_call } from "../../../../data/ApiEndpoints";
import "../../../../styles/lead-mangement/click-to-call.css";
import {
  BuildingIcon1,
  CalendarIcon,
  CallIcon,
  CallIcon1,
  EmailIcon,
  GenderIcon,
  PeopleIcon,
  PersonIcon,
  SourceIcon,
  TagIcon,
  XIcon,
} from "../../../../images/icons/icons";
import { formatDate } from "../../../../utils/utilityfunc";
import LeadFollowupNewUI from "../lead-journey/LeadFollowupNewUI";

const ClickToCall = ({ userInfoData, closeModal, rowData }) => {
  const dispatch = useDispatch();
  const {
    userMappedFeaturesV1,
    userMappedFeaturesV1Loading,
    userMappedFeaturesV1Error,
  } = useSelector((state) => state.features);
  
  const [isLoading, setIsLoading] = useState(false);
  const [ivrDetails, setIvrDetails] = useState({});
  const [showFollowupForm, setShowFollowupForm] = useState(false);

  const formatLeadStage = (stage) => {
    if (!stage) return "NA";
    return stage
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handleClickToCall = async () => {
    if (!rowData?.mobile) {
      toast.error("Mobile number not available");
      return;
    }

    if (ivrDetails?.did_num === "N/A" || ivrDetails?.ext_no === "N/A") {
      toast.error("IVR details not available");
      return;
    }

    setIsLoading(true);

    const payload = {
      did: ivrDetails?.did_num || "",
      ext_no: ivrDetails?.ext_no || "",
      phone: rowData?.mobile || "",
    };

    try {
      const result = await dispatch(
        commonPostPutApi({
          method: "POST",
          endpoint: ivr_initiate_call,
          payload,
          token: userInfoData?.token || "",
        })
      );

      if (result?.payload?.status) {
        toast.success(
          result?.payload?.message || "Call initiated successfully!"
        );
        setShowFollowupForm(true);
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Failed to initiate call");
      }
    } catch (error) {
      console.error("Error initiating call:", error);
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (
      !userMappedFeaturesV1Loading &&
      !userMappedFeaturesV1Error &&
      userMappedFeaturesV1?.ivr_details
    ) {
      setIvrDetails(userMappedFeaturesV1.ivr_details);
    } else {
      setIvrDetails({});
    }
  }, [
    userMappedFeaturesV1Loading,
    userMappedFeaturesV1Error,
    userMappedFeaturesV1,
  ]);

  if (showFollowupForm) {
    return (
      <div className="click-to-call-container">
        <div className="click-to-call-header">
          <div className="click-to-call-header-content">
            <h2 className="click-to-call-title">Schedule Follow-up</h2>
            <p className="click-to-call-subtitle">
              Call initiated successfully. Please schedule the follow-up.
            </p>
          </div>
          <button className="click-to-call-close-btn" onClick={closeModal}>
            <XIcon />
          </button>
        </div>
        <LeadFollowupNewUI
          userInfoData={userInfoData}
          rowData={rowData}
          closeModal={closeModal}
        />
      </div>
    );
  }

  return (
    <div className="click-to-call-container">
      <div className="click-to-call-header">
        <div className="click-to-call-header-content">
          <h2 className="click-to-call-title">Lead Details</h2>
          <p className="click-to-call-subtitle">
            Review lead information before initiating the call
          </p>
        </div>
        <button className="click-to-call-close-btn" onClick={closeModal}>
          <XIcon />
        </button>
      </div>

      <div className="click-to-call-section">
        <div className="click-to-call-section-header">
          <PeopleIcon color="#6366f1" />
          <h3 className="click-to-call-section-title">Member Information</h3>
        </div>

        <div className="click-to-call-grid">
          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Name</span>
            <span className="click-to-call-field-value">
              <PersonIcon color="#6b7280" />
              {rowData?.name || "NA"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Mobile</span>
            <span className="click-to-call-field-value click-to-call-mobile">
              <CallIcon color="#6b7280" />
              {rowData?.mobile || "-"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Email</span>
            <span className="click-to-call-field-value lowercase">
              <EmailIcon color="#6b7280" />
              {rowData?.email || "-"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Gender</span>
            <span className="click-to-call-field-value">
              <GenderIcon color="#6b7280" />
              {rowData?.gender
                ? rowData.gender.charAt(0).toUpperCase() +
                  rowData.gender.slice(1)
                : "NA"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Gym</span>
            <span className="click-to-call-field-value">
              <BuildingIcon1 />
              {rowData?.gym_name || "NA"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Source</span>
            <span className="click-to-call-field-value">
              <SourceIcon color="#6b7280" />
              {rowData?.source_name
                ? rowData.source_name.replace(/_/g, " ").toUpperCase()
                : "NA"}
            </span>
          </div>
        </div>
      </div>

      <div className="click-to-call-section">
        <div className="click-to-call-section-header">
          <TagIcon />
          <h3 className="click-to-call-section-title">Lead Status</h3>
        </div>

        <div className="click-to-call-grid">
          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Lead Stage</span>
            <span className="click-to-call-field-value">
              {formatLeadStage(rowData?.mem_lead_stage)}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Lead Status</span>
            <span className="click-to-call-field-value">
              {rowData?.lead_status
                ? rowData.lead_status.charAt(0).toUpperCase() +
                  rowData.lead_status.slice(1)
                : "NA"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Customer Intent</span>
            <span className="click-to-call-field-value">
              {rowData?.cutomer_intent || "NA"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">
              Current Followup Status
            </span>
            <span className="click-to-call-field-value">
              {rowData?.current_followup_status?.replace(/_/g, " ") || "NA"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Date Added</span>
            <span className="click-to-call-field-value">
              <CalendarIcon color="#6b7280" />
              {formatDate(rowData?.date_added)}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Next Followup</span>
            <span className="click-to-call-field-value">
              <CalendarIcon color="#6b7280" />
              {formatDate(rowData?.next_followup_date)}
            </span>
          </div>
        </div>
      </div>

      <div className="click-to-call-section">
        <div className="click-to-call-section-header">
          <PeopleIcon color="#6366f1" />
          <h3 className="click-to-call-section-title">Added By</h3>
        </div>

        <div className="click-to-call-grid click-to-call-grid-3">
          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Name</span>
            <span className="click-to-call-field-value">
              {rowData?.added_by_name || "NA"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Mobile</span>
            <span className="click-to-call-field-value">
              {rowData?.added_by_mobile || "-"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Email</span>
            <span className="click-to-call-field-value lowercase">
              {rowData?.added_by_email || "-"}
            </span>
          </div>
        </div>
      </div>

      <div className="click-to-call-section">
        <div className="click-to-call-section-header">
          <PeopleIcon color="#6366f1" />
          <h3 className="click-to-call-section-title">Assigned To</h3>
        </div>

        <div className="click-to-call-grid click-to-call-grid-3">
          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Name</span>
            <span className="click-to-call-field-value">
              {rowData?.assigned_to_name || "NA"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Mobile</span>
            <span className="click-to-call-field-value">
              {rowData?.assigned_to_mobile || "-"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Email</span>
            <span className="click-to-call-field-value lowercase">
              {rowData?.assigned_to_email || "-"}
            </span>
          </div>
        </div>
      </div>

      <div className="click-to-call-section">
        <div className="click-to-call-section-header">
          <PeopleIcon color="#6366f1" />
          <h3 className="click-to-call-section-title">Logged In User</h3>
        </div>

        <div className="click-to-call-grid">
          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Name</span>
            <span className="click-to-call-field-value">
              {userInfoData?.name || "NA"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Mobile</span>
            <span className="click-to-call-field-value">
              <CallIcon color="#6b7280" />
              {userInfoData?.mobile || "-"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Email</span>
            <span className="click-to-call-field-value lowercase">
              {userInfoData?.email || "-"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Account Type</span>
            <span className="click-to-call-field-value">
              {userInfoData?.account_type
                ? userInfoData.account_type.charAt(0).toUpperCase() +
                  userInfoData.account_type.slice(1)
                : "NA"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Gym</span>
            <span className="click-to-call-field-value">
              <BuildingIcon1 />
              {userInfoData?.gym_name || "NA"}
            </span>
          </div>
        </div>
      </div>

      <div className="click-to-call-section">
        <div className="click-to-call-section-header">
          <CallIcon color="#6366f1" />
          <h3 className="click-to-call-section-title">IVR Details</h3>
        </div>

        <div className="click-to-call-grid click-to-call-grid-3">
          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Extension No</span>
            <span className="click-to-call-field-value">
              {ivrDetails?.ext_no || "NA"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">DID Number</span>
            <span className="click-to-call-field-value">
              {ivrDetails?.did_num || "NA"}
            </span>
          </div>

          <div className="click-to-call-field">
            <span className="click-to-call-field-label">Agent Mobile</span>
            <span className="click-to-call-field-value">
              {ivrDetails?.agent_mobile || "NA"}
            </span>
          </div>
        </div>
      </div>

      <div className="click-to-call-section">
        <div className="click-to-call-section-header">
          <CallIcon color="#6366f1" />
          <h3 className="click-to-call-section-title">Call Statistics</h3>
        </div>

        <div className="click-to-call-stats">
          <div className="click-to-call-stat-card">
            <span className="click-to-call-stat-value">
              {rowData?.total_outgoing_call || "0"}
            </span>
            <span className="click-to-call-stat-label">
              Total Outgoing Calls
            </span>
          </div>

          <div className="click-to-call-stat-card click-to-call-stat-success">
            <span className="click-to-call-stat-value">
              {rowData?.total_outgoing_connected_call || "0"}
            </span>
            <span className="click-to-call-stat-label">Connected Calls</span>
          </div>

          <div className="click-to-call-stat-card click-to-call-stat-info">
            <span className="click-to-call-stat-value">
              {rowData?.follow_up_number || "0"}
            </span>
            <span className="click-to-call-stat-label">Follow-ups Done</span>
          </div>
        </div>
      </div>

      <div className="click-to-call-actions">
        <button
          className="click-to-call-btn click-to-call-btn-secondary"
          onClick={closeModal}
        >
          Cancel
        </button>
        <button
          className="click-to-call-btn click-to-call-btn-primary"
          onClick={handleClickToCall}
          disabled={isLoading || !rowData?.mobile}
        >
          {isLoading ? (
            <>
              <span className="click-to-call-spinner"></span>
              Initiating Call...
            </>
          ) : (
            <>
              <CallIcon1 />
              Click to Call
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ClickToCall;
